import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { ReactNode } from 'react';
import { FieldError } from 'react-hook-form';

import {
  ScheduledEmploymentOption,
  useScheduleEmployments,
} from '../../useScheduleEmployments';

export interface ScheduleEmploymentsDropdownProps {
  value: string | number;
  onChange: (
    event: SelectChangeEvent<string | number>,
    child: ReactNode,
  ) => void;
  error: FieldError | undefined;
  readOnlyMode: boolean;
}
export const ScheduleEmploymentsDropdown = ({
  value,
  onChange,
  error,
  readOnlyMode,
}: ScheduleEmploymentsDropdownProps) => {
  const { scheduledEmploymentOptions, isLoading, hasUpcomingEmployments } =
    useScheduleEmployments();

  const getOptionName = (option: ScheduledEmploymentOption) => {
    let string = `${option.startDate} - ${option.endDate || 'Continous'}`;
    string += option.addons ? ` (${option.addons})` : '';
    return string;
  };

  if (isLoading || !hasUpcomingEmployments) {
    return <></>;
  }

  return (
    <FormControl fullWidth={true} error={!!error?.message}>
      <InputLabel required id="selectEmploymentLabel">
        Select Employment
      </InputLabel>
      <Select
        value={value}
        onChange={onChange}
        disabled={readOnlyMode}
        required={true}
        label="Select Employment"
        labelId="selectEmploymentLabel"
      >
        {scheduledEmploymentOptions.map((option) => (
          <MenuItem key={option.id} value={option?.id}>
            {getOptionName(option)}
          </MenuItem>
        ))}
      </Select>
      {error?.message && (
        <FormHelperText error={!!error?.message}>
          {error?.message}
        </FormHelperText>
      )}
    </FormControl>
  );
};
